export { S4AMastheadProvider, useS4AMastheadContext, } from './S4AMastheadProvider';
//# sourceMappingURL=index.js.map